module.exports = __webpack_public_path__ + "fonts/Inter-900-latin84.30a274c.woff2";